// import React, { useState, useEffect } from 'react';
// import { motion } from 'framer-motion';
// import './Gallery.css';
// import { useLanguage } from '../context/LanguageContext';

// /* Scroll-reveal hook */
// const useScrollReveal = (selector, options = {}) => {
//   useEffect(() => {
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in-view'); });
//     }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px', ...options });
//     document.querySelectorAll(selector).forEach(el => observer.observe(el));
//     return () => observer.disconnect();
//   }, [selector]);
// };

// const PageHero = ({ pill, title }) => (
//   <div className="gallery-hero">
//     <div className="gallery-hero-bg" />
//     <div className="gallery-hero-overlay" />
//     <div className="gallery-hero-rays" aria-hidden="true">
//       {[1,2,3,4,5].map(i => <span key={i} className={`hero-ray hero-ray-${i}`} />)}
//     </div>
//     <div className="gallery-hero-content">
//       <span className="page-hero-pill">{pill}</span>
//       <h1 className="page-hero-title">{title}</h1>
//       <div className="page-hero-divider">
//         <span className="phd-line" /><span className="phd-diamond">◆</span><span className="phd-line" />
//       </div>
//     </div>
//     <div className="page-hero-bottom-line" />
//   </div>
// );

// const Gallery = () => {
//   const { t } = useLanguage();
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [activeCategory, setActiveCategory] = useState('all');

//   useScrollReveal('.reveal');

//   const galleryItems = [
//     { id: 1,  category: 'temple',    titleKey: 'gallery.galleryItems.mainTemple',     descKey: 'gallery.galleryItems.mainTempleDesc',     image: '/Assets/home/dev.jpg' },
//     { id: 2,  category: 'temple',    titleKey: 'gallery.galleryItems.templeEntrance', descKey: 'gallery.galleryItems.templeEntranceDesc', image: '/Assets/home/mukhya dwar.jpg' },
//     { id: 3,  category: 'temple',    titleKey: 'gallery.galleryItems.innerSanctum',   descKey: 'gallery.galleryItems.innerSanctumDesc',   image: '/Assets/home/main mandir.jpg' },
//     { id: 13, category: 'temple',    titleKey: 'gallery.galleryItems.drushya1',       descKey: 'gallery.galleryItems.drushya1Desc',       image: '/Assets/gallery/drushya_1.jpg' },
//     { id: 14, category: 'temple',    titleKey: 'gallery.galleryItems.drushya2',       descKey: 'gallery.galleryItems.drushya2Desc',       image: '/Assets/gallery/drushya_2.jpg' },
//     { id: 15, category: 'temple',    titleKey: 'gallery.galleryItems.drushya3',       descKey: 'gallery.galleryItems.drushya3Desc',       image: '/Assets/gallery/drushya_3.jpg' },
//     { id: 16, category: 'temple',    titleKey: 'gallery.galleryItems.drushya4',       descKey: 'gallery.galleryItems.drushya4Desc',       image: '/Assets/gallery/drushya_4.jpg' },
//     { id: 17, category: 'temple',    titleKey: 'gallery.galleryItems.drushya5',       descKey: 'gallery.galleryItems.drushya5Desc',       image: '/Assets/gallery/drushya_5.jpg' },
//     { id: 4,  category: 'festival',  titleKey: 'gallery.galleryItems.san1',           descKey: 'gallery.galleryItems.san1Desc',           image: '/Assets/gallery/san_1.jpg' },
//     { id: 5,  category: 'festival',  titleKey: 'gallery.galleryItems.san2',           descKey: 'gallery.galleryItems.san2Desc',           image: '/Assets/gallery/san_2.jpg' },
//     { id: 6,  category: 'festival',  titleKey: 'gallery.galleryItems.san3',           descKey: 'gallery.galleryItems.san3Desc',           image: '/Assets/gallery/san_3.jpg' },
//     { id: 9,  category: 'facilities',titleKey: 'gallery.galleryItems.bhaktaNiwas',    descKey: 'gallery.galleryItems.bhaktaNiwasDesc',    image: '/Assets/gallery/bhakta niwas.jpg' },
//     { id: 10, category: 'facilities',titleKey: 'gallery.galleryItems.annaKshetra',    descKey: 'gallery.galleryItems.annaKshetraDesc',    image: '/Assets/gallery/annas seva.jpg' },
//     { id: 11, category: 'facilities',titleKey: 'gallery.galleryItems.templeGarden',   descKey: 'gallery.galleryItems.templeGardenDesc',   image: '/Assets/gallery/garden.jpg' },
//     { id: 12, category: 'facilities',titleKey: 'gallery.galleryItems.gauShala',       descKey: 'gallery.galleryItems.gauShalaDesc',       image: '/Assets/gallery/gau shala.jpg' },
//   ];

//   const categories = [
//     { id: 'all',       labelKey: 'gallery.all' },
//     { id: 'temple',    labelKey: 'gallery.temple' },
//     { id: 'festival',  labelKey: 'gallery.festivals' },
//     { id: 'facilities',labelKey: 'gallery.facilities' },
//   ];

//   const filteredItems = activeCategory === 'all' ? galleryItems : galleryItems.filter(item => item.category === activeCategory);

//   return (
//     <motion.div 
//       className="gallery-page"
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.5 }}
//     >
//       <PageHero pill={t('gallery.pageTitle')} title={t('gallery.pageSubtitle')} />

//       <div className="container">
//         <div className="gallery-filters reveal">
//           {categories.map(cat => (
//             <button key={cat.id} className={`filter-btn ${activeCategory === cat.id ? 'active' : ''}`} onClick={() => setActiveCategory(cat.id)}>
//               <span>{t(cat.labelKey)}</span>
//             </button>
//           ))}
//         </div>

//         <div className="gallery-grid">
//           {filteredItems.map((item, index) => (
//             <div 
//               key={item.id} 
//               className="gallery-item reveal" 
//               onClick={() => setSelectedImage(item)}
//               style={{ '--stagger-index': index % 10 }}
//             >
//               <img src={item.image} alt={t(item.titleKey)} className="gallery-image" loading="lazy" />
//               <div className="gallery-overlay">
//                 <h3>{t(item.titleKey)}</h3>
//                 <p>{t(item.descKey)}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {selectedImage && (
//         <div className="lightbox" onClick={() => setSelectedImage(null)}>
//           <div className="lightbox-content" onClick={e => e.stopPropagation()}>
//             <button className="close-btn" onClick={() => setSelectedImage(null)}>×</button>
//             <img src={selectedImage.image} alt={t(selectedImage.titleKey)} className="lightbox-image" />
//             <h3 className="lightbox-title">{t(selectedImage.titleKey)}</h3>
//             <p className="lightbox-description">{t(selectedImage.descKey)}</p>
//           </div>
//         </div>
//       )}
//     </motion.div>
//   );
// };

// export default Gallery;











import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './Gallery.css';
import { useLanguage } from '../context/LanguageContext';

/* Scroll-reveal hook */
const useScrollReveal = (selector, options = {}) => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in-view'); });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px', ...options });
    document.querySelectorAll(selector).forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [selector]);
};

const PageHero = ({ pill, title }) => (
  <div className="gallery-hero">
    <div className="gallery-hero-bg" />
    <div className="gallery-hero-overlay" />
    <div className="gallery-hero-rays" aria-hidden="true">
      {[1,2,3,4,5].map(i => <span key={i} className={`hero-ray hero-ray-${i}`} />)}
    </div>
    <div className="gallery-hero-content">
      <span className="page-hero-pill">{pill}</span>
      <h1 className="page-hero-title">{title}</h1>
      <div className="page-hero-divider">
        <span className="phd-line" /><span className="phd-diamond">◆</span><span className="phd-line" />
      </div>
    </div>
    <div className="page-hero-bottom-line" />
  </div>
);

const Gallery = () => {
  const { t } = useLanguage();
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeCategory, setActiveCategory] = useState('all');

  useScrollReveal('.gallery-scroll-wrapper');

  /* ── Category बदलल्यावर items ला in-view add करा ── */
  useEffect(() => {
    const timer = setTimeout(() => {
      document.querySelectorAll('.gallery-item').forEach((el, idx) => {
        setTimeout(() => el.classList.add('in-view'), idx * 50);
      });
    }, 50);
    return () => clearTimeout(timer);
  }, [activeCategory]);

  const galleryItems = [
    { id: 1,  category: 'temple',     titleKey: 'gallery.galleryItems.mainTemple',     descKey: 'gallery.galleryItems.mainTempleDesc',     image: '/Assets/home/dev.jpg' },

     { id: 14,  category: 'temple',     titleKey: 'gallery.galleryItems.mandirArea',     descKey: 'gallery.galleryItems.mandirAreaDesc',     image: '/Assets/gallery/mandir1.png' },

    { id: 2,  category: 'temple',     titleKey: 'gallery.galleryItems.templeEntrance', descKey: 'gallery.galleryItems.templeEntranceDesc', image: '/Assets/home/mukhya dwar.jpg' },
    { id: 3,  category: 'temple',     titleKey: 'gallery.galleryItems.innerSanctum',   descKey: 'gallery.galleryItems.innerSanctumDesc',   image: '/Assets/home/main mandir.jpg' },
    { id: 13, category: 'temple',     titleKey: 'gallery.galleryItems.drushya1',       descKey: 'gallery.galleryItems.drushya1Desc',       image: '/Assets/gallery/drushya_1.jpg' },
    { id: 14, category: 'temple',     titleKey: 'gallery.galleryItems.drushya2',       descKey: 'gallery.galleryItems.drushya2Desc',       image: '/Assets/gallery/drushya_2.jpg' },
    { id: 15, category: 'temple',     titleKey: 'gallery.galleryItems.drushya3',       descKey: 'gallery.galleryItems.drushya3Desc',       image: '/Assets/gallery/drushya_3.jpg' },
    { id: 16, category: 'temple',     titleKey: 'gallery.galleryItems.drushya4',       descKey: 'gallery.galleryItems.drushya4Desc',       image: '/Assets/gallery/drushya_4.jpg' },
    { id: 17, category: 'temple',     titleKey: 'gallery.galleryItems.drushya5',       descKey: 'gallery.galleryItems.drushya5Desc',       image: '/Assets/gallery/drushya_5.jpg' },
    { id: 4,  category: 'festival',   titleKey: 'gallery.galleryItems.san1',           descKey: 'gallery.galleryItems.san1Desc',           image: '/Assets/gallery/san_1.jpg' },
    { id: 5,  category: 'festival',   titleKey: 'gallery.galleryItems.san2',           descKey: 'gallery.galleryItems.san2Desc',           image: '/Assets/gallery/san_2.jpg' },
    { id: 6,  category: 'festival',   titleKey: 'gallery.galleryItems.san3',           descKey: 'gallery.galleryItems.san3Desc',           image: '/Assets/gallery/san_3.jpg' },
    { id: 9,  category: 'facilities', titleKey: 'gallery.galleryItems.bhaktaNiwas',    descKey: 'gallery.galleryItems.bhaktaNiwasDesc',    image: '/Assets/gallery/bhakta niwas.jpg' },
    { id: 10, category: 'facilities', titleKey: 'gallery.galleryItems.annaKshetra',    descKey: 'gallery.galleryItems.annaKshetraDesc',    image: '/Assets/gallery/annas seva.jpg' },
    { id: 11, category: 'facilities', titleKey: 'gallery.galleryItems.templeGarden',   descKey: 'gallery.galleryItems.templeGardenDesc',   image: '/Assets/gallery/garden.jpg' },
    { id: 12, category: 'facilities', titleKey: 'gallery.galleryItems.gauShala',       descKey: 'gallery.galleryItems.gauShalaDesc',       image: '/Assets/gallery/gau shala.jpg' },
     { id: 13, category: 'temple', titleKey: 'gallery.galleryItems.vovry',       descKey: 'gallery.galleryItems.vovryaDesc',       image: '/Assets/gallery/vovrya.png' },
      { id: 15, category: 'temple', titleKey: 'gallery.galleryItems.ghoda',       descKey: 'gallery.galleryItems.ghodaDesc',       image: '/Assets/gallery/Panchdhatu Ghoda.jpg' },
  ];

  const categories = [
    { id: 'all',        labelKey: 'gallery.all' },
    { id: 'temple',     labelKey: 'gallery.temple' },
    { id: 'festival',   labelKey: 'gallery.festivals' },
    { id: 'facilities', labelKey: 'gallery.facilities' },
  ];

  const filteredItems = activeCategory === 'all'
    ? galleryItems
    : galleryItems.filter(item => item.category === activeCategory);

  const handleCategoryChange = (catId) => {
    /* in-view काढा — नवीन animate साठी */
    document.querySelectorAll('.gallery-item').forEach(el => el.classList.remove('in-view'));
    setActiveCategory(catId);
  };

  return (
    <motion.div
      className="gallery-page"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <PageHero pill={t('gallery.pageTitle')} title={t('gallery.pageSubtitle')} />

      <div className="container">

        {/* Filter buttons — parchment scroll */}
        <section className="gallery-filter-section">
          <div className="gallery-scroll-wrapper in-view">
            <div className="gallery-scroll-content">
              <h2 className="gallery-scroll-title">{t('gallery.pageSubtitle')}</h2>
              <div className="parchment-divider" />
              <div className="gallery-filters">
                {categories.map(cat => (
                  <button
                    key={cat.id}
                    className={`filter-btn ${activeCategory === cat.id ? 'active' : ''}`}
                    onClick={() => handleCategoryChange(cat.id)}
                  >
                    <span>{t(cat.labelKey)}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Gallery Grid */}
        <section className="gallery-grid-section">
          <div className="gallery-grid">
            {filteredItems.map((item, index) => (
              <div
                key={item.id}
                className="gallery-item"
                onClick={() => setSelectedImage(item)}
              >
                <img
                  src={item.image}
                  alt={t(item.titleKey)}
                  className="gallery-image"
                  loading="lazy"
                />
                <div className="gallery-overlay">
                  <h3>{t(item.titleKey)}</h3>
                  <p>{t(item.descKey)}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelectedImage(null)}>×</button>
            <img
              src={selectedImage.image}
              alt={t(selectedImage.titleKey)}
              className="lightbox-image"
            />
            <h3 className="lightbox-title">{t(selectedImage.titleKey)}</h3>
            <p className="lightbox-description">{t(selectedImage.descKey)}</p>
          </div>
        </div>
      )}
    </motion.div>
  );
};

export default Gallery;